import React from 'react';
import { X } from 'lucide-react';
import BankAccountForm from './BankAccountForm';

/**
 * Bank Account Modal — shown when booking a Delhivery International shipment
 * without bank details on file. Styled like PriceBreakdownModal.
 *
 * Props:
 *  - isOpen
 *  - onClose — user closes the popup without saving
 *  - existingAccount: bank account object (edit mode when partially set up)
 *  - onSaved(account): called after the user saves their bank details
 */
const BankAccountModal = ({ isOpen, onClose, existingAccount = null, onSaved }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full p-6 relative max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X size={24} />
        </button>

        <div className="mb-6">
          <h2 className="text-lg font-bold text-[#1a2b4b]">Add Bank Account Details</h2>
          <p className="text-xs text-gray-500 mt-1">
            Bank details are required to book Delhivery International shipments
          </p>
        </div>

        <BankAccountForm
          existingAccount={existingAccount}
          onSaved={onSaved}
        />
      </div>
    </div>
  );
};

export default BankAccountModal;
